import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(5),
  },
}))

export default styles
